import { Type } from 'class-transformer';
import { DimensionResultDto } from '../../common/dimensions/dimension-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';

export class CashReceiptItemResultDto extends UpdatedResultDto {
    cmCashReceiptItemId: number;

    @Type(() => Date)
    clearDate: Date;

    reconciled: boolean;
    postMethod: string;
    glAccountNumber: string;
    offsetGLAccountNumber: string;
    accountLabel: string;
    subCategory: string;
    amount: number;
    openBalance: number;
    description: string;

    @Type(() => DimensionResultDto)
    dimensions: DimensionResultDto[];
}
